<label for="fileInput" class="btn attachment">
	<i class="bi bi-paperclip"></i>{{ 'attachment.addDocuments' | translate }}
	<input type="file" class="form-control-file col-md-4" id="fileInput" (change)="uploadFiles($event)" multiple />
</label>
<p><ngb-progressbar type="primary" *ngIf="showProgress" [value]="progressUpload" height=".5rem"></ngb-progressbar></p>
